<script>
import Layout from "@/router/layouts/main";
import { api } from "@/state/services";

export default {
  locales: {
    pt: {
      'Order': 'Pedido',
      'Orders': 'Pedidos',
      'My Plan': 'Meu Plano',
      'Payment Method': 'Forma de Pagamento',
      'Order Date': 'Data do Pedido',

      'Items': 'Itens',
      'Item': 'Item',
      'Total': 'Total',
      'Price': 'Preço',
      'Qty': 'Qtd',
      'Value': 'Valor',
      'Status': 'Status',
      'Date': 'Data',

      'Switch plans': 'Trocar de Plano',
      'Current choice': 'Escolha Atual',
      'Choose': 'Escolher',
      'Plan name': 'Nome do Plano',
      'Plans': 'Planos',

      'Awaiting payment': 'Aguardando pagamento',
      'Payment confirmed': 'Pagamento confirmado',

      'Address': 'Endereço',
      'Send exactly value to make payment': 'Envie exatamente o valor para efetuar o pagamento',

      'The order was not found.': 'O pedido não foi encontrado.',

      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Pedimos desculpas, não podemos recuperar informações no momento. Por favor, tente novamente mais tarde.',
      'No records found.': 'Nenhum registro encontrado.',

      'Use the QR code to proceed with the transaction.': 'Use o código QR para prosseguir com a transação.',
      'Or use Pix Copy and Paste to proceed with the transaction.': 'Ou utilize o Pix Copia e Cola para prosseguir com a transação.',
      'Use Pix Copy and Paste to proceed with the transaction.': 'Use o Pix Copia e Cola para prosseguir com a transação.',
      'Copy Pix Copy and Paste': 'Copiar Pix Copia e Cola',
      'Copied to clipboard.': 'Copiado para a área de transferência.',
      'Now, all you need to do is access your bank app and complete the process using Pix Copy and Paste.': 'Agora, tudo o que você precisa fazer é acessar o aplicativo do seu banco e concluir o processo usando o Pix Copia e Cola.',
      'Number of Installments': 'Número de Parcelas',
      'Card Number': 'Número do Cartão',
      'Cardholder Name': 'Nome do Titular',
      'Expiration': 'Vencimento',
      'Month': 'Mês',
      'Year': 'Ano',
      'Security Code': 'Código de Segurança',
      'Pay': 'Pagar',
      'Please wait!': 'Aguarde!',
      'We are processing your payment!': 'Estamos processando o seu pagamento!',
      'An error occurred while processing the payment, please try again.': 'Ocorreu um erro ao processar o pagamento, tente novamente.',
      'The order was paid successfully.': 'O pedido foi pago com sucesso.',
      'This order is not available for payment or already paid.': 'Este pedido não está disponível para pagamento ou já foi pago.',
      'The amount entered is invalid.': 'O valor informado é inválido.',
      'The minimum amount per card is %amount%.': 'O valor mínimo por cartão é %amount%.',
      'This order has reached the limit of 5 cards.': 'Este pedido já atingiu o limite de 5 cartões.',
      'Enter the full name and CPF of the cardholder.': 'Informe o nome completo e o CPF do titular do cartão.',
      'Unable to validate the cardholder.': 'Não foi possível validar o titular do cartão.',
      'The user was not found.': 'O usuário não foi encontrado.',
      'Unable to create the customer.': 'Não foi possível criar o cliente.',
      'The amount entered is no longer valid for this order.': 'O valor informado não é mais válido para este pedido.',
      'The payment was approved, but an error occurred while recording it. Please contact support.': 'O pagamento foi aprovado, mas ocorreu um erro ao registrá-lo. Entre em contato com o suporte.',
      'Please fill in all fields.': 'Por favor, preencha todos os campos.',
    },
    es: {
      'Order': 'Pedido',
      'Orders': 'Pedidos',
      'My Plan': 'Mi Plan',
      'Payment Method': 'Forma de Pago',
      'Order Date': 'Fecha del Pedido',

      'Items': 'Artículos',
      'Item': 'Artículo',
      'Total': 'Total',
      'Price': 'Precio',
      'Qty': 'Cant.',
      'Value': 'Valor',
      'Status': 'Estado',
      'Date': 'Fecha',

      'Switch plans': 'Cambiar de Plan',
      'Current choice': 'Elección Actual',
      'Choose': 'Elegir',
      'Plan name': 'Nombre del Plan',
      'Plans': 'Planes',

      'Awaiting payment': 'En espera de pago',
      'Payment confirmed': 'Pago confirmado',

      'Address': 'Dirección',
      'Send exactly value to make payment': 'Envía exactamente el monto para realizar el pago',

      'The order was not found.': 'El pedido no fue encontrado.',

      'We apologize, we are unable to retrieve information at this time. Please try again later.': 'Nos disculpamos, no podemos recuperar información en este momento. Por favor, inténtalo de nuevo más tarde.',
      'No records found.': 'No se encontraron registros.',

      'Use the QR code to proceed with the transaction.': 'Usa el código QR para continuar con la transacción.',
      'Or use Pix Copy and Paste to proceed with the transaction.': 'O usa Pix Copiar y Pegar para continuar con la transacción.',
      'Use Pix Copy and Paste to proceed with the transaction.': 'Usa Pix Copiar y Pegar para continuar con la transacción.',
      'Copy Pix Copy and Paste': 'Copiar Pix Copiar y Pegar',
      'Copied to clipboard.': 'Copiado al portapapeles.',
      'Now, all you need to do is access your bank app and complete the process using Pix Copy and Paste.': 'Ahora, todo lo que necesitas hacer es acceder a la app de tu banco y completar el proceso usando Pix Copiar y Pegar.',
      'Number of Installments': 'Número de Cuotas',
      'Card Number': 'Número de la Tarjeta',
      'Cardholder Name': 'Nombre del Titular',
      'Expiration': 'Vencimiento',
      'Month': 'Mes',
      'Year': 'Año',
      'Security Code': 'Código de Seguridad',
      'Pay': 'Pagar',
      'Please wait!': '¡Espera!',
      'We are processing your payment!': '¡Estamos procesando tu pago!',
      'An error occurred while processing the payment, please try again.': 'Ocurrió un error al procesar el pago, inténtalo de nuevo.',
      'The order was paid successfully.': 'El pedido se pagó con éxito.',
      'This order is not available for payment or already paid.': 'Este pedido no está disponible para pago o ya fue pagado.',
      'The amount entered is invalid.': 'El monto ingresado no es válido.',
      'The minimum amount per card is %amount%.': 'El monto mínimo por tarjeta es %amount%.',
      'This order has reached the limit of 5 cards.': 'Este pedido ya alcanzó el límite de 5 tarjetas.',
      'Enter the full name and CPF of the cardholder.': 'Ingresa el nombre completo y el CPF del titular de la tarjeta.',
      'Unable to validate the cardholder.': 'No fue posible validar al titular de la tarjeta.',
      'The user was not found.': 'No se encontró el usuario.',
      'Unable to create the customer.': 'No fue posible crear el cliente.',
      'The amount entered is no longer valid for this order.': 'El monto ingresado ya no es válido para este pedido.',
      'The payment was approved, but an error occurred while recording it. Please contact support.': 'El pago fue aprobado, pero ocurrió un error al registrarlo. Ponte en contacto con soporte.',
      'Please fill in all fields.': 'Por favor, completa todos los campos.',
    }
  },
  components: {
    Layout,
  },
  data() {
    return {
      loading: true,
      errored: false,
      empty: false,
      plans: null,

      order: {
        id: this.$route.params.id,
        date: null,

        subtotal: '0.00',
        discount: '0.00',
        shipping: {
          method: '',
          value: '0.00',
          address: {
            zipcode: '',
            address: '',
            number: '',
            complement: '',
            district: '',
            city: '',
            state: '',
          }
        },
        payment: {
          methods: {},
          list: [],
        },

        total: '0.00',

        items: null,
        status: null,
      },

      balance: {
        modal: false,
        loading: false,
        pay: '0.00',
        total: '0.00',
      },

      pix: {
        text: '',
        image: '',
      },

      creditcard: {
        loading: false,
        modal: false,
        ip: '',
        installments: [],
        installment: '1',
        number: '',
        expiryMonth: '',
        expiryYear: '',
        cvv: '',
        holderName: '',
      },
    };
  },
  methods: {
    getOrder() {
      if (this.order.id) {
        api
          .get('store/orders/' + this.order.id)
          .then(response => {
            if (response.data.status == 'success') {
              this.order = response.data.order

              this.loading = false

              if (this.order.payment.status == 'pending') {
                if (this.order.payment.methods.pix) {
                  this.gerarPix();
                }

                if (this.order.payment.methods.creditcard) {
                  this.getInstallments();
                }
              }

              this.getBalance();
            } else {
              this.empty = true
              this.message = this.t(response.data.message)
            }
          })
          .catch(error => {
            this.errored = error
          })
      }
    },
    gerarPix() {
      api
        .post('store/orders/' + this.order.id + '/pix')
        .then(response => {
          if (response.data.status == 'success') {
            this.pix.text  = response.data.pix.text;
            this.pix.image = response.data.pix.image;
          }
        })
    },
    getInstallments() {
      api
        .post('store/orders/' + this.order.id + '/creditcard/installments')
        .then(response => {
          if (response.data.status == 'success') {
            this.creditcard.installments = response.data.installments;
          }
        })
    },
    getBalance() {
      api
        .get('wallet/balance/network')
        .then(response => {
          if (response.data.status == 'success') {
            this.balance.total = response.data.balance
            this.balance.pay = parseFloat(this.balance.total) - parseFloat(this.order.total);
          }
        })
    },
    payBalance() {
      this.balance.loading = true;

      api
        .post('wallet/pay/' + this.order.id)
        .then(response => {
          if (response.data.status == 'success') {
            this.$toast.success(this.t('The order was paid successfully.'))
            this.getOrder();
          }
        })
        .catch(error => {
          if (error) {
            this.balance.loading = false;
          }
        })
        .finally(() => {
          this.balance.loading = false;
        })
    },
    payCreditCard() {
      this.creditcard.loading = true;
      this.creditcard.modal = true;

      api
        .post('store/orders/' + this.order.id + '/creditcard', {
          installment: this.creditcard.installment,
          number: this.creditcard.number,
          holderName: this.creditcard.holderName,
          expiryMonth: this.creditcard.expiryMonth,
          expiryYear: this.creditcard.expiryYear,
          cvv: this.creditcard.cvv,
          ip: this.creditcard.ip,
        })
        .then(response => {
          if (response.data.status == 'success') {
            this.$toast.success(this.t('The order was paid successfully.'))

            this.creditcard.loading = false;
            this.creditcard.modal = false;
            this.getOrder();
          } else {
            this.creditcard.loading = false;
            this.creditcard.modal = false;

            let message = this.t(response.data.message)
            if (response.data.amount) message = message.replace('%amount%', response.data.amount)

            this.$toast.error(message)
          }
        })
        .catch(error => {
          if (error) {
            this.creditcard.loading = false;
            this.creditcard.modal = false;
            this.$toast.error(this.t('An error occurred while processing the payment, please try again.'))
          }
        })
        .finally(() => {
          this.creditcard.loading = false;
          this.creditcard.modal = false;
        })
    },
    getIp() {
      fetch('https://api.ipify.org?format=json')
        .then(response => response.json())
        .then(data => {
          if (data.ip) {
            this.creditcard.ip = data.ip;
          }
        });
    },
  },
  mounted() {
    this.getOrder()
    this.getIp()
  },
};
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z">
            </path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item"><router-link tag="a" to="/subscriptions">{{ t('My Plan') }}</router-link></li>
      <li class="breadcrumb-item d-none d-sm-block">{{ t('Order') }}</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between mb-3">
      <div>
        <h3>{{ t('Orders') }}</h3>
        <p></p>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-10 mx-auto">
        <div class="card">
          <div class="card-body p-4">
            <div v-if="errored">{{ t('We apologize, we are unable to retrieve information at this time. Please try again later.') }}</div>
            <div v-else-if="empty">{{ t('No records found.') }}</div>
            <div v-else-if="loading">
              <div class="min-vh-25 d-flex justify-content-center align-items-center">
                <b-spinner variant="default" role="status"></b-spinner>
              </div>
            </div>
            <div v-else>
              <div class="d-flex">
                <h4 class="mb-0 font-size-15 flex-fill">
                  #{{ order.id }}
                </h4>
                <h4 class="mb-0 font-size-15 flex-fill text-right">
                  {{ order.date }}
                </h4>
              </div>
              <hr />
              <div class="table-responsive">
                <table class="table table-nowrap">
                  <thead>
                    <tr>
                      <th class="border-0 text-uppercase text-center">{{ t('Item') }}</th>
                      <th class="border-0 text-uppercase text-center">{{ t('Total') }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(td, index) in order.items" :key="index">
                      <td class="text-center">{{ td.name }} </td>
                      <td class="text-center">{{ td.subtotal | currency }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <h3 class="font-size-16 mb-2 mt-4 text-center">{{ t('Status') }}</h3>
              <div v-for="(td, index) in order.status" :key="index" class="text-center">
                {{ td.date }} — {{ t(td.status) }}
              </div>
              <b-tabs v-if="order.payment.status === 'pending'" justified nav-class="nav-tabs-custom mt-5" content-class="p-3 text-muted">
                <b-tab v-for="(pay, method) in order.payment.methods" :key="method">
                  <template v-slot:title>{{ pay.name }}</template>
                  <div v-if="method == 'pix'" class="py-3 text-center">
                    <div v-if="pix.text">
                      <div v-if="pix.image">
                        <div>
                          {{ t('Use the QR code to proceed with the transaction.') }}
                        </div>
                        <div class="my-4 d-flex justify-content-center">
                          <div class="border rounded p-3">
                            <img style="width: 180px" :src="'data:image/png;base64,' + pix.image" />
                          </div>
                        </div>
                        <div>
                          {{ t('Or use Pix Copy and Paste to proceed with the transaction.') }}
                        </div>
                      </div>
                      <div v-else>
                        {{ t('Use Pix Copy and Paste to proceed with the transaction.') }}
                      </div>
                      <div class="my-4">
                        <fieldset class="text-break py-3">{{ pix.text }}</fieldset>
                      </div>
                      <div>
                        <button class="btn btn-default btn-lg btn-block text-uppercase" v-clipboard:copy="pix.text"
                          v-on:click="$toast.success('<strong>' + t('Copied to clipboard.') + '</strong><br>' + t('Now, all you need to do is access your bank app and complete the process using Pix Copy and Paste.'))">
                          {{ t('Copy Pix Copy and Paste') }}
                        </button>
                      </div>
                    </div>
                  </div>
                  <div v-else-if="method == 'creditcard'">
                    <div class="row justify-content-center">
                      <b-form class="col-md-6" @submit.prevent="payCreditCard">
                        <div class="my-5">
                          <b-form-group :label="t('Number of Installments')" label-for="creditcard.installment">
                            <b-form-select id="installment" v-model="creditcard.installment" :options="creditcard.installments" required></b-form-select>
                          </b-form-group>
                          <b-form-group :label="t('Card Number')" label-for="number">
                            <b-form-input id="number" v-model="creditcard.number" type="text" required v-mask="'#### #### #### ####'"></b-form-input>
                          </b-form-group>
                          <b-form-group :label="t('Cardholder Name')" label-for="holderName">
                            <b-form-input id="holderName" v-model="creditcard.holderName" type="text" required></b-form-input>
                          </b-form-group>
                          <div class="row">
                            <div class="col-12 col-md-6">
                              <b-form-group :label="t('Expiration')" label-for="expiryDate">
                                <b-input-group>
                                  <b-form-input id="expiryMonth" v-model="creditcard.expiryMonth" type="text" :placeholder="t('Month')" maxlength="2" required v-mask="'##'"></b-form-input>
                                  <b-form-input id="expiryYear" v-model="creditcard.expiryYear" type="text" :placeholder="t('Year')" maxlength="2" required v-mask="'##'"></b-form-input>
                                </b-input-group>
                              </b-form-group>
                            </div>
                            <div class="col-12 col-md-6">
                              <b-form-group :label="t('Security Code')" label-for="cvv">
                                <b-form-input id="cvv" v-model="creditcard.cvv" type="text" required v-mask="'###'"></b-form-input>
                              </b-form-group>
                            </div>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center">
                          <button class="btn btn-default btn-lg mr-3" type="submit" :disabled="creditcard.loading">
                            {{ t('Pay') }}
                            <b-spinner v-if="creditcard.loading" small class="ml-2 align-middle" variant="secondary" role="status"></b-spinner>
                          </button>
                        </div>
                      </b-form>
                    </div>
                  </div>
                </b-tab>
              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal v-model="creditcard.modal" modal-class="modal-center" hide-header hide-footer centered no-close-on-backdrop no-close-on-esc>
      <div class="text-center py-4">
        <div class="d-flex justify-content-center align-items-center mb-4">
          <b-spinner large class="align-middle" variant="default" role="status"></b-spinner>
        </div>
        <h5>{{ t('Please wait!') }}</h5>
        <h6>{{ t('We are processing your payment!') }}</h6>
      </div>
    </b-modal>
  </Layout>
</template>